<div id="cl-wrapper" class="login-container login-theme">

  <div class="row no-margin-top" style="display: flex; justify-content: center; align-items: center; height: 800px;">

 
      <div class="block-flat" style="width: 600px;">
        <div class="header">
          <h3 class="text-center">
            <img alt="logo" class="img-responsive logo-img">
          </h3>
        </div>
        <div class="form-horizontal" style="font-size: 14px;">
          <div class="content">
            <h2>{{'TERMS_CONDITIONS' | translate}}</h2>

            <ul>
              <li>
                <span>{{'TERMS_CONDITIONS_P1'|translate}}
                  <a target="_blank" [href]="termsConditionsUrl" [innerHtml]="termsConditionsUrl"></a> .
                </span>
              </li>
              <li>
                <span>{{'TERMS_CONDITIONS_P2'|translate}}
                </span>
              </li>
              <li>
                <span>{{'TERMS_CONDITIONS_P3'|translate}}
                </span>
              </li>
            </ul>


          </div>
          <div class="foot">
            <div class="text-center">
              <a class="color-default small" [href]="loginFooterUrl" target="_blank" [innerHtml]="loginFooterText"></a>
            </div>
          </div>



        </div>

      </div>

 

  </div>
</div>